import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Helmet from 'react-helmet/es/Helmet';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Popover from '@material-ui/core/Popover';
import ErrorIcon from '@material-ui/icons/Error';
import MaterialTable from 'material-table';
import PopupState, { bindTrigger, bindPopover } from 'material-ui-popup-state';
import Papa from 'papaparse';
import { useMutation, Query } from 'react-apollo';
import moment from 'moment';
import {
  GET_FLAGGED_DEADLINES,
  UPDATE_DEADLINE
} from 'graphql/colleges';
import useSnack from 'hooks/useSnack';
import SearchBar from 'components/common/Search';
import Spin from 'components/common/Spin';


const Errors = ({ }) => {
  const snack = useSnack();
  const [updateDeadline] = useMutation(UPDATE_DEADLINE);

  const columns = [
    { title: 'College', field: 'college.name' },
    { title: 'Type or Special Program', field: 'program_type' },
    { title: 'Admission Type', field: 'admission_type' },
    {
      title: 'Application Deadline',
      field: 'deadline',
      render: (row) => {
        if (row.flagged) {
          return (
            <PopupState variant="popover" popupId={`deadline-${row.id}`}>
              {(popupState) => (
                <div>
                  <Box display="inline-block" {...bindTrigger(popupState)}>
                    <Box display="flex" alignItems="center">
                      <ErrorIcon color="error" />
                      &nbsp;
                      <Typography variant="body2" color="error" style={{ cursor: 'pointer'}}>
                        {moment(row.deadline).format('L')}
                      </Typography>
                    </Box>
                  </Box>
                  <Popover
                    {...bindPopover(popupState)}
                    anchorOrigin={{
                      vertical: 'top',
                      horizontal: 'center',
                    }}
                    transformOrigin={{
                      vertical: 'bottom',
                      horizontal: 'center',
                    }}
                  >
                    <Box padding={2}>
                      <Typography variant="body2">
                        Correct date:{' '}
                        <strong>
                          {moment(row.suggested_date).format('L')}
                        </strong>
                      </Typography>
                      <Typography variant="body2">
                        Suggested by{' '}
                        <strong>
                          {row.flagged_user.user_first_name}{' '}
                          {row.flagged_user.user_last_name}
                        </strong>
                      </Typography>
                      <Box marginTop={2} textAlign="right">
                        <Button
                          variant="text"
                          color="secondary"
                          onClick={handleSkipSuggestion(row, popupState)}
                        >
                          Skip
                        </Button>{' '}
                        <Button
                          variant="text"
                          color="primary"
                          onClick={handleConfirmSuggestion(row, popupState)}
                        >
                          Confirm
                        </Button>
                      </Box>
                    </Box>
                  </Popover>
                </div>
              )}
            </PopupState>
          );
        }
        return moment(row.deadline).format('L');
      },
    },
    {
      title: 'Suggested Deadline',
      field: 'suggested_date',
      type: 'date'
    },
    {
      title: 'Suggested By',
      field: 'flagged_user.user_first_name',
      render: (row) => `${row.flagged_user.user_first_name} ${row.flagged_user.user_last_name}`
    }
  ];

  const handleSkipSuggestion = (row, popupState) => () => {
    popupState.close();
    updateDeadline({
      variables: {
        id: row.id,
        data: {
          flagged: false,
          flagged_by: null,
          suggested_date: null
        }
      }
    })
      .then(() => snack.success('Suggestion skipped'))
      .catch(
        (e) => snack.error(e.message)
      )
  };

  const handleConfirmSuggestion = (row, popupState) => () => {
    popupState.close();
    updateDeadline({
      variables: {
        id: row.id,
        data: {
          flagged: false,
          flagged_by: null,
          suggested_date: null,
          deadline: row.suggested_date
        }
      }
    })
      .then(() => snack.success('Suggestion accepted'))
      .catch(
        (e) => snack.error(e.message)
      )
  };

  return (
    <Box>
      <Helmet title="College Database Errors" />
      <Query query={GET_FLAGGED_DEADLINES} fetchPolicy={'cache-and-network'}>
        {({ data, loading }) => {
          if (loading) return <Spin spinning />;

          return (
            <MaterialTable
              title="Reported deadlines"
              options={{
                pageSize: 10
              }}
              columns={columns}
              data={data.rows.filter(i => i.flagged)}
            />
          )
        }}
      </Query>
    </Box>
  )
}

export default Errors;